export { default as ReporteHorasTrabajadas } from './HorasTrabajadas';
export { default as DetalleHorasTrabajadas } from './DetalleHorasTrabajadas';
